import { useEffect, useState, type CSSProperties } from 'react';
import { MdKeyboardDoubleArrowUp } from 'react-icons/md';

interface Props {
  targetRef: React.RefObject<HTMLElement | null>;
  className?: string;
}

export default function BackToSearchBar({ targetRef, className = '' }: Props) {
  const [showBar, setShowBar] = useState(false);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      if (!targetRef.current) return;

      const rect = targetRef.current.getBoundingClientRect();
      // 検索条件エリアが画面外に出た場合にバーを表示
      setShowBar(rect.bottom < 0);
    };

    window.addEventListener('scroll', onScroll);
    onScroll(); // 初期表示時にもチェック

    return () => window.removeEventListener('scroll', onScroll);
  }, [targetRef]);

  useEffect(() => {
    const updateHeaderHeight = () => {
      const header = document.getElementById('agent-header');
      setHeaderHeight(header?.offsetHeight ?? 0);
    };

    updateHeaderHeight();
    window.addEventListener('resize', updateHeaderHeight);

    return () => window.removeEventListener('resize', updateHeaderHeight);
  }, []);

  const barStyle: CSSProperties = headerHeight
    ? {
        top: headerHeight,
      }
    : {};

  const scrollToSearch = () => {
    targetRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  if (!showBar) return null;

  return (
    <div
      className={`fixed right-0 left-[250px] z-40 flex h-12 cursor-pointer items-center justify-center border-b border-solid border-gray-200 bg-[#F6F6F6CC] transition-all duration-200 ${className}`}
      style={barStyle}
      onClick={scrollToSearch}
    >
      <div className="flex items-center gap-2 font-bold">
        <span>検索条件に戻る</span>
        <MdKeyboardDoubleArrowUp className="size-5" />
      </div>
    </div>
  );
}
